import { createSelector } from "reselect"
import { chain, get, startsWith } from "lodash"
import { getContentSets } from "selectors/contentSets"
import { getModelFactors } from "selectors/modelMetadata"
import { getExposure as getExposureConstraints } from "./constraints"

const EMPTY_ARRAY = []

export const getFactorsSearchValue = state => get(state, "modules.optimizationSettings.factorsSearchValue")
export const getFactorsSearchVisible = state => get(state, "modules.optimizationSettings.factorsSearchVisible")

export const getFactorsSearchResults = createSelector(
  [getFactorsSearchValue, getModelFactors, getContentSets, getExposureConstraints],
  (searchValue, factorsMetadata, contentSets, exposureConstraints) => {
    if (searchValue) {
      return [
        ...chain(factorsMetadata)
          .map(({ label }, id) => ({
            name: label,
            id,
            disabled: !!exposureConstraints[id],
          }))
          .filter(({ name }) => startsWith(name.toLowerCase(), searchValue.toLowerCase()))
          .value(),
        ...chain(contentSets)
          .map(contentSet => chain(contentSet.factors)
            .map(({ name, id }) => ({
              name,
              id,
              contentSetId: contentSet.id,
              disabled: !!exposureConstraints[`${contentSet.id}.${id}`],
            }))
            .filter(({ name }) => startsWith(name.toLowerCase(), searchValue.toLowerCase()))
            .value())
          .flatten()
          .value(),
      ]
    }

    return EMPTY_ARRAY
  },
)
